<template>
  <DiamondStock
      :showMenu="true"
      :stockSearch="labGrownSearch"
      :key="{labGrownSearch}"
      :sType="5"
  />
</template>
<script>
import DiamondStock from "@/components/DiamondStock";
import {reactive} from "vue";

export default {
  name: "lab-grown",
  components: {
    DiamondStock
  },
  props: {
    labSearch: {
      type: Object
    }
  },
  setup(props) {
    const labGrownSearch = reactive(props.labSearch);

    return {
      labGrownSearch
    }
  }
}
</script>